import { atom, useSetAtom } from 'jotai'
import { draftSearchCriteria$ } from './draft'
import { type SearchCriteria, zRadius } from './validate'

const RADIUS_RANGES_KM = [0.1, 0.2, 0.3, 0.5, 0.8, 1, 3, 5] as const satisfies readonly number[]

export const radiusRanges: [label: string, value: string][] = RADIUS_RANGES_KM.map((r) => [
  formatRadius(r),
  String(r),
])

export function formatRadius(radius: number): string {
  return radius < 1 ? `${radius * 1000}m` : `${radius}km`
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('formatRadius', () => {
    expect(formatRadius(0.1)).toEqual('100m')
    expect(formatRadius(1)).toEqual('1km')
  })
}

export function useSetDraftRadius() {
  return useSetAtom(setDraftRadius$)
}

const setDraftRadius$ = atom<null, [number], SearchCriteria | undefined>(
  null,
  (get, set, radius) => {
    const isValid = zRadius.safeParse(radius).success
    if (isValid) {
      set(draftSearchCriteria$, (current) => {
        return { ...current, radius }
      })
    }
    return get(draftSearchCriteria$)
  }
)
if (import.meta.vitest) {
  const { describe, test, expect } = import.meta.vitest
  const { createStore } = await import('jotai')
  describe('setDraftRadius$', () => {
    test('半径を指定する', () => {
      const store = createStore()
      store.set(draftSearchCriteria$, {
        largeAreaCode: '07',
        mediumAreaCode: '002',
        radius: 0.2,
      } as SearchCriteria)
      const result = store.set(setDraftRadius$, 0.5)
      expect(result).toStrictEqual({
        largeAreaCode: '07',
        mediumAreaCode: '002',
        radius: 0.5,
      })
    })
  })
}
